"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * The toolbar title.
 */


var ToolbarTitle = function ToolbarTitle(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement("span", {
    className: (0, _classnames2.default)("mdc-toolbar__title", className)
  }, children);
};

exports.default = ToolbarTitle;